import { render, staticRenderFns } from "./EditSocialCampaignLinkModal.vue?vue&type=template&id=64676102&"
import script from "./EditSocialCampaignLinkModal.vue?vue&type=script&lang=js&"
export * from "./EditSocialCampaignLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports